import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { apsas } from "../../../json/apsas";


const Apsas = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Administración del Patrimonio Social Apoyos y Subsidios</h1>
          </div>
          <div class="alert alert-info text-justify" role="alert">
          En el Hipervínculo al padrón de beneficiarios o participantes en la  tabla que se muestra, se omiten los apellidos, CURP y RFC de acuerdo al artículo 3 fracciones VII y VIII que establece el concepto de datos personales y que con ello pueden hacer identificables a su titular, por lo anterior  y de conformidad a la fracción XI se hace la disociación de datos,  motivo por el que se eliminan los apellidos  con el objetivo de no hacer identificables a los titulares de la información de carácter sensible que se publican en esta fracción, correlacionado con lo que establecen los lineamientos técnicos generales al mencionar que dicha publicación debe de ser cuidando los datos de estas características. De acuerdo por lo dispuesto por la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados para el Estado de Hidalgo, toda vez pueden afectar la esfera más íntima del titular o cuya utilización indebida puede dar origen a discriminación o estigmatización y a su vez conlleve a un riesgo grave, el monto o apoyo a cada beneficiario se otorga a cada paciente que requiera según sea necesidad de salud, el cual puede ser de manera subsecuente (mensual o trimestral). De acuerdo a la naturaleza del programa no se requiere de la tabla adyacente el criterio Denominación social, toda vez que son personas físicas.
</div>
              
        </div>
      </div>
    
       <div className="steps-row">
       {apsas.map((item, index) => (
          <div key={index} className="col-12 seccion">
            <h1 className="titulo-seccion"></h1>
            <div className="bloque">
           
             
            <h5 className="mt-3 titulo-bloque">{item.titulo_item_nombre}</h5>
            
            <div className="cuerpo-bloque">
                {item.archivos.map((tram, i) => (
                  <div>
                 
                 
                  <a className={tram.extencion}
                    target="{_blank}"
                    key={i}
                    href={tram.file_item_url}
                  >
                    {tram.file_item_nombre}
                  </a>
                </div>
                ))}
              </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Apsas;
